<template>
  <div class="append-box" @touchmove="gtouchmove">
    <logoImg :show="showLogo"></logoImg>
    <v-mask style="background:none;"></v-mask>
    <div class="horizontal-center progress-box">
      <p class="p-title">{{text}}({{percent}})</p>
      <div class="progress">
        <div class="progress-bar" :style="{width:percent}"></div>
      </div>
    </div>
  </div>
</template>

<script>
import vmask from "@/components/mask.vue";
import logoImg from "@/components/logoImg.vue";
export default {
  name: "downLoad",
  components: {
    "v-mask": vmask,
    logoImg: logoImg
  },
  data() {
    return {
      text: "正在下载中",
      showLogo: true,
      percent: "0%"
    };
  },
  methods: {
    gtouchmove(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    update(percent) {
      this.percent = percent + "%";
    },
    updateText(txt) {
      this.text = txt;
    }
  }
};
</script>

<style lang="scss" scoped>
.append-box {
  z-index: 9999;
  .progress-box {
    color: #ffffff;
    bottom: 0.25rem;
    .p-title {
      font-size: 0.15rem;
      padding: 0;
      color: white;
      margin: 0 auto;
      text-align: center;
      margin-bottom: 0.1rem;
      line-height: 0.2rem;
      height: 0.2rem;
    }
    .progress {
      height: 0.04rem;
      background: url(~@/assets/img/UI_common_loading_01.png) no-repeat;
      overflow: visible;
      border-radius: 0.1rem;
      padding: 0.02rem;
      width: 1.92rem;
      margin: 0 auto;
      -webkit-border-radius: 0.1rem;
      -moz-border-radius: 0.1rem;
      -ms-border-radius: 0.1rem;
      -o-border-radius: 0.1rem;
      position: relative;
      .progress-bar {
        position: absolute;
        left: 0;
        top: 0;
        width: 0;
        height: 100%;
        height: 0.04rem;
        color: #fff;
        text-align: center;
        background: url(~@/assets/img/UI_common_loading_02.png) no-repeat;
        -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
        box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
        -webkit-transition: width 0.6s ease;
        -o-transition: width 0.6s ease;
        transition: width 0.6s ease;
      }
    }
  }
}
@media all and (orientation: portrait) {
  .progress-box {
    transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    -o-transform: rotate(90deg);
  }
}
</style>